import { render } from "./MaterialCreate.vue?vue&type=template&id=bff204a6"
import script from "./MaterialCreate.vue?vue&type=script&lang=js"
export * from "./MaterialCreate.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__